import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminEventModel } from '../../shared/models/admin-event-models';
import { EventModel } from '../../shared/models/event-models';
import { Observable, of, interval } from 'rxjs';
import { catchError, shareReplay, startWith, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TodayEventsService {
  private cachedAdminEvents$: Observable<AdminEventModel[]>;
  private cachedHearings$: Observable<EventModel[]>;
  private cachedSpecialEvents$: Observable<EventModel[]>;
  private cachedSessions$: Observable<EventModel[]>;
  private cachedTodayHearings$: Observable<EventModel[]>;
  private cachedTodaySpecialEvents$: Observable<EventModel[]>;
  private cachedTodaySessions$: Observable<EventModel[]>;

  constructor(private httpClient: HttpClient) { }

  private todayEventsApiBaseUrl = 'api/Events';

  getAdminEvents(): Observable<AdminEventModel[]> {
    if (!this.cachedAdminEvents$) {
      this.cachedAdminEvents$ = interval(1 * 20_000).pipe(
        startWith(0),
        switchMap(() =>
          this.httpClient.get<AdminEventModel[]>(this.todayEventsApiBaseUrl + '/AdminEvents').pipe(
            catchError(error => {
              console.error('Error fetching admin events:', error);
              return of([]);
            })
          )
        ),
        shareReplay(1)
      );
    }
    return this.cachedAdminEvents$;
  }

  getHearings(): Observable<EventModel[]> {
    if (!this.cachedHearings$) {
      this.cachedHearings$ = interval(1 * 20_000).pipe(
        startWith(0),
        switchMap(() =>
          this.httpClient.get<EventModel[]>(this.todayEventsApiBaseUrl + '/Hearings').pipe(
            catchError(error => {
              console.error('Error fetching hearings:', error);
              return of([]);
            })
          )
        ),
        shareReplay(1),
      );
    }
    return this.cachedHearings$;
  }

  getSpecialEvents(): Observable<EventModel[]> {
    if (!this.cachedSpecialEvents$) {
      this.cachedSpecialEvents$ = interval(1 * 20_000).pipe(
        startWith(0),
        switchMap(() =>
          this.httpClient.get<EventModel[]>(this.todayEventsApiBaseUrl + '/SpecialEvents').pipe(
            catchError(error => {
              console.error('Error fetching special events:', error);
              return of([]);
            })
          )
        ),
        shareReplay(1),
      );
    }
    return this.cachedSpecialEvents$;
  }

  getSessions(): Observable<EventModel[]> {
    if (!this.cachedSessions$) {
      this.cachedSessions$ = interval(1 * 20_000).pipe(
          startWith(0),
          switchMap(() =>
            this.httpClient.get<EventModel[]>(this.todayEventsApiBaseUrl + '/Sessions').pipe(
              catchError(error => {
                console.error('Error fetching sessions:', error);
                return of([]);
              })
            )
          ),
          shareReplay(1),
        );
    }
    return this.cachedSessions$;
  }


  getTodayHearings(): Observable<EventModel[]> {
    if (!this.cachedTodayHearings$) {
      this.cachedTodayHearings$ = interval(1 * 20_000).pipe(
        startWith(0),
        switchMap(() =>
          this.httpClient.get<EventModel[]>(this.todayEventsApiBaseUrl + '/TodayHearings').pipe(
            catchError(error => {
              console.error('Error fetching today\'s hearings:', error);
              return of([]);
            })
          )
        ),
        shareReplay(1),
      );
    }
    return this.cachedTodayHearings$;
  }

  getTodaySpecialEvents(): Observable<EventModel[]> {
    if (!this.cachedTodaySpecialEvents$) {
      this.cachedTodaySpecialEvents$ = interval(1 * 20_000).pipe(
        startWith(0),
        switchMap(() =>
          this.httpClient.get<EventModel[]>(this.todayEventsApiBaseUrl + '/TodaySpecialEvents').pipe(
            catchError(error => {
              console.error('Error fetching today\'s special events:', error);
              return of([]);
            })
          )
        ),
        shareReplay(1),
      );
    }
    return this.cachedTodaySpecialEvents$;
  }

  getTodaySessions(): Observable<EventModel[]> {
    if (!this.cachedTodaySessions$) {
      this.cachedTodaySessions$ = interval(1 * 20_000).pipe(
        startWith(0),
        switchMap(() =>
          this.httpClient.get<EventModel[]>(this.todayEventsApiBaseUrl + '/TodaySessions').pipe(
            catchError(error => {
              console.error('Error fetching today\'s sessions:', error);
              return of([]);
            })
          )
        ),
        shareReplay(1),
      );
    }
    return this.cachedTodaySessions$;
  }

  clearCache(): void {
    this.cachedAdminEvents$ = null;
    this.cachedHearings$ = null;
    this.cachedSpecialEvents$ = null;
    this.cachedSessions$ = null;
    this.cachedTodayHearings$ = null;
    this.cachedTodaySpecialEvents$ = null;
    this.cachedTodaySessions$ = null;
  }
}
